import {NgModule} from '@angular/core';
import {ResourceSummaryContainer} from "./resource-summary-container.component";
import {CommonModule} from "@angular/common";
import {ResourceSummaryComponent} from "./resource-summary.component";
import {GenericResourceSummaryComponent} from "./generic-resource-summary.component";
import {WebmateBrowserModule} from "../browser/webmate-browser.module";
import {DragulaModule} from 'ng2-dragula';
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";

@NgModule({
    declarations: [
        ResourceSummaryContainer,
        ResourceSummaryComponent,
        GenericResourceSummaryComponent,
    ],
    imports: [
        CommonModule,
        WebmateBrowserModule,
        DragulaModule,
        CheckboxModule,
        FormsModule,
    ],
    exports: [
        ResourceSummaryContainer,
        ResourceSummaryComponent,
        GenericResourceSummaryComponent
    ]
})
export class ResourceViewsModule {
}
